import { T } from "components/util/t";
import { Redirect, useLocation, useRouteMatch } from "react-router-dom";
import { useRef } from "react";
import { GET_CURRENT_HEATS } from "graphql/event";
import { GetCurrentHeatsQuery } from "graphql/event.types";
import { useQuery } from "@apollo/client";
import { ActionNotificationSticky } from "components/notifications/ActionNotificationSticky";
import { isHeatSupported } from "./isHeatSupported";
import { useFeatureFlags } from "components/providers/featureFlags/useFeatureFlags";

export const NewScoringInterfaceNotification = () => {
    const isOldJudgePage = useRouteMatch("/events/:id/scoring") as { params: { id: string } } | null;
    const hasOptedOut = useRef(false);
    const { state }: { state: { optout: boolean } } = useLocation();
    const eventId = isOldJudgePage?.params.id;

    if (state?.optout) hasOptedOut.current = true;

    const { data } = useQuery<GetCurrentHeatsQuery>(GET_CURRENT_HEATS, {
        variables: { id: eventId },
        fetchPolicy: "cache-and-network",
        skip: !isOldJudgePage,
    });

    const isNewScoringInterfaceNotificationEnabled = useFeatureFlags("New scoring UI notification");
    if (!isNewScoringInterfaceNotificationEnabled) return null;

    if (!isOldJudgePage || !isHeatSupported(data?.event?.currentHeats?.filter(currentHeat => currentHeat !== null))) return null;

    return hasOptedOut.current
        ? <ActionNotificationSticky text={<T eventId={eventId}>new_scoring_interface_notification</T>}/>
        : <Redirect to={`/events/${eventId}/judge`}/>;
};
